import React from 'react';
import strikon from '../data/strikon.png';

export const NonPulsingStrike = () => (
  <div style={{
    position: "relative",
    width: "30px",
    height: "30px"
  }}>
    <img 
      src={strikon} 
      style={{
        position: "absolute",
        width: "20px",
        height: "20px",
        top: "5px",
        left: "5px"
      }}
      alt="collision emoji"
    />
  </div>
)


// WEBPACK FOOTER //
// ./src/components/strategy/wsde/nonPulsingStrike.js